// ui/Card — canonical card structure (header / body / footer), tokens only.
// Use `nested` for a card inside another card's body (Layer 2 surface, no shadow).
// Replaces the unused legacy card.js. See card.css for the anatomy.
import React from "react";
import "./card.css";
import CardBoundary from "./CardBoundary";

export function Card({ nested = false, className = "", children, ...rest }) {
  return (
    <div className={`abon-card ${nested ? "abon-card--nested" : ""} ${className}`} {...rest}>
      <CardBoundary>{children}</CardBoundary>
    </div>
  );
}

export function CardHeader({ title, subtitle, actions, className = "", children }) {
  return (
    <div className={`abon-card__header ${className}`}>
      {children ?? (
        <div className="abon-card__heading">
          {title ? <h3 className="abon-card__title">{title}</h3> : null}
          {subtitle ? <span className="abon-card__subtitle">{subtitle}</span> : null}
        </div>
      )}
      {actions ? <div className="abon-card__actions">{actions}</div> : null}
    </div>
  );
}

export function CardBody({ flush = false, className = "", children }) {
  return <div className={`abon-card__body ${flush ? "abon-card__body--flush" : ""} ${className}`}>{children}</div>;
}

export function CardFooter({ className = "", children }) {
  return <div className={`abon-card__footer ${className}`}>{children}</div>;
}

export default Card;
